import { createSelector } from 'reselect';
import type { AddressesState } from '../../types';

const selectAddresses = (state: AddressesState) => state;

const selectShippingAddress = createSelector(
  [selectAddresses],
  addresses => addresses?.shippingAddress
);

const selectShippingAddressPostalCode = createSelector(
  [selectShippingAddress],
  shippingAddress => shippingAddress?.postalCode
);

const selectShippingAddressCountry = createSelector(
  [selectShippingAddress],
  shippingAddress => shippingAddress?.country
);

export default {
  selectShippingAddressPostalCode,
  selectShippingAddressCountry,
};
